// extracted by mini-css-extract-plugin
export default {"cta":"fG-z","disabled":"gG-z"};